import React from 'react';
export function EngagementPlan() {
  return <div data-id="element-2534">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2535">
        Engagement Plan
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2536">
        Configure your customer engagement strategies and workflows
      </p>

      <div className="space-y-6" data-id="element-2537">
        {/* Engagement Strategy */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2538">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2539">
            Engagement Strategy
          </h2>
          <div className="space-y-4" data-id="element-2540">
            <div data-id="element-2541">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2542">
                Default Follow-up Cadence
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2543">
                <option data-id="element-2544">Immediate (within 1 hour)</option>
                <option data-id="element-2545">Same Day (within 8 hours)</option>
                <option data-id="element-2546">Next Day</option>
                <option data-id="element-2547">Custom</option>
              </select>
            </div>
            <div data-id="element-2548">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2549">
                Maximum Follow-up Attempts
              </label>
              <input type="number" placeholder="3" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2550" />
            </div>
          </div>
        </div>

        {/* Communication Channels */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2551">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2552">
            Preferred Communication Channels
          </h2>
          <div className="space-y-3" data-id="element-2553">
            <label className="flex items-center" data-id="element-2554">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2555" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2556">WhatsApp</span>
            </label>
            <label className="flex items-center" data-id="element-2557">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2558" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2559">Phone Call</span>
            </label>
            <label className="flex items-center" data-id="element-2560">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2561" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2562">Email</span>
            </label>
            <label className="flex items-center" data-id="element-2563">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2564" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2565">SMS</span>
            </label>
          </div>
        </div>

        {/* Auto-Assignment Rules */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2566">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2567">
            Lead Auto-Assignment
          </h2>
          <div className="space-y-4" data-id="element-2568">
            <div data-id="element-2569">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2570">
                Assignment Method
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2571">
                <option data-id="element-2572">Round Robin</option>
                <option data-id="element-2573">Based on Availability</option>
                <option data-id="element-2574">Based on Performance</option>
                <option data-id="element-2575">Manual Assignment</option>
              </select>
            </div>
            <label className="flex items-center" data-id="element-2576">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2577" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2578">
                Automatically assign hot leads to top performers
              </span>
            </label>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2579">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2580">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}